export class ScrollMenu {
  constructor() {
    this.header = document.querySelector('.site-header');
    this.lastScrollY = 0;
    this.isMenuHidden = false;
    this.scrollThreshold = 10;
    this.hideAfter = window.innerHeight * 0.5;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.init();
  }

  init() {
    if (!this.header) return;

    this.header.style.transition = 'transform 0.3s ease-out';
    this.header.style.transform = 'translateY(0)';

    if (this.prefersReducedMotion) return;

    this.handleScroll = this.throttle(this.handleScroll.bind(this), 16);
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    window.addEventListener('resize', this.throttle(() => {
      this.hideAfter = window.innerHeight * 0.5;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }, 250));

    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => {
      this.prefersReducedMotion = e.matches;
      if (this.prefersReducedMotion && this.isMenuHidden) {
        this.showMenu();
      }
    });
  }

  handleScroll() {
    const currentScrollY = window.pageYOffset;
    const scrollDifference = currentScrollY - this.lastScrollY;

    if (Math.abs(scrollDifference) < this.scrollThreshold) return;

    if (currentScrollY <= this.hideAfter) {
      if (this.isMenuHidden) this.showMenu();
      this.lastScrollY = currentScrollY;
      return;
    }

    if (scrollDifference > 0 && !this.isMenuHidden) {
      this.hideMenu();
    } else if (scrollDifference < 0 && this.isMenuHidden) {
      this.showMenu();
    }

    this.lastScrollY = currentScrollY;
  }

  hideMenu() {
    this.isMenuHidden = true;
    const headerHeight = this.header.offsetHeight;
    this.header.style.transition = this.prefersReducedMotion ? 'none' : 'transform 0.3s ease-out';
    this.header.style.transform = `translateY(-${headerHeight}px)`;
    this.announceToScreenReader("Navigazione nascosta");
  }

  showMenu() {
    this.isMenuHidden = false;
    this.header.style.transition = this.prefersReducedMotion ? 'none' : 'transform 0.4s ease-out';
    this.header.style.transform = 'translateY(0)';
    this.announceToScreenReader("Navigazione visibile");
  }

  announceToScreenReader(message) {
    const announcement = document.createElement('div');
    announcement.textContent = message;
    announcement.setAttribute('aria-live', 'polite');
    announcement.setAttribute('aria-atomic', 'true');
    announcement.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden';
    document.body.appendChild(announcement);
    setTimeout(() => document.body.removeChild(announcement), 1000);
  }

  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }

  destroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
